import { getNormalizedPrice } from './getNormalizedPrice'

export const getSignedPrice = (price: number): string =>
  `${price > 0 ? '+' : ''}${getNormalizedPrice(price)}`
